import React from "react";
import { Link } from "react-scroll";
import { useLocation } from 'react-router-dom';
// Assets
import CloseIcon from "../../assets/svg/CloseIcon";
import LogoIcon from "../../assets/svg/Logo";

export default function Sidebar({ sidebarOpen, toggleSidebar }) {
  let location = useLocation();
  return (
    <nav className={`fixed top-0 right-0 h-screen w-full sm:w-96 bg-white z-[9999] transition-transform duration-300 ${sidebarOpen ? 'translate-x-0' : 'translate-x-full'}`}>
      <div className="flex items-center justify-between p-5 border-b">
        <div className="flex items-center">
          {location.pathname === '/' ?
            (<Link className="flex items-center cursor-pointer" to="home" smooth={true}>
              <LogoIcon />
            </Link>)
            :
            (<a style={{ padding: "10px 15px" }} href="/"><LogoIcon /></a>)
          }
        </div>
        <button aria-label="Close menu" onClick={() => toggleSidebar(!sidebarOpen)} className="p-2">
          <CloseIcon />
        </button>
      </div>

      <ul className="flex flex-col items-start p-10 space-y-5">
        <li className="font-medium text-sm cursor-pointer">
          {location.pathname === '/' ?
            (<Link
              onClick={() => toggleSidebar(!sidebarOpen)}
              activeClass="border-b-2 border-amber-500 text-amber-500"
              className="px-4 py-2 hover:text-amber-500"
              to="home"
              spy={true}
              smooth={true}
              offset={-60}
            >
              Home
            </Link>)
            :
            (<a className="px-4 py-2 hover:text-amber-500" href="/">Home</a>)
          }
        </li>
        <li className="font-medium text-sm cursor-pointer">
          {location.pathname === '/' ?
            (<Link
              onClick={() => toggleSidebar(!sidebarOpen)}
              activeClass="border-b-2 border-amber-500 text-amber-500"
              className="px-4 py-2 hover:text-amber-500"
              to="about-us"
              spy={true}
              smooth={true}
              offset={-60}
            >
              Über uns
            </Link>)
            :
            (<a className="px-4 py-2 hover:text-amber-500" href="/#about-us">Über uns</a>)
          }
        </li>
        <li className="font-medium text-sm cursor-pointer">
          {location.pathname === '/' ?
            (<Link
              onClick={() => toggleSidebar(!sidebarOpen)}
              activeClass="border-b-2 border-amber-500 text-amber-500"
              className="px-4 py-2 hover:text-amber-500"
              to="services"
              spy={true}
              smooth={true}
              offset={-60}
            >
              Dienstleistungen
            </Link>)
            :
            (<a className="px-4 py-2 hover:text-amber-500" href="/#services">Dienstleistungen</a>)
          }
        </li>
        <li className="font-medium text-sm cursor-pointer">
          {location.pathname === '/' ?
            (<Link
              onClick={() => toggleSidebar(!sidebarOpen)}
              activeClass="border-b-2 border-amber-500 text-amber-500"
              className="px-4 py-2 hover:text-amber-500"
              to="locations"
              spy={true}
              smooth={true}
              offset={-60}
            >
              Einsatzorte
            </Link>)
            :
            (<a className="px-4 py-2 hover:text-amber-500" href="/#locations">Einsatzorte</a>)
          }

        </li>
        <li className="font-medium text-sm cursor-pointer">
          {location.pathname === '/' ?
            (<Link
              onClick={() => toggleSidebar(!sidebarOpen)}
              activeClass="border-b-2 border-amber-500 text-amber-500"
              className="px-4 py-2 hover:text-amber-500"
              to="fuhrpark"
              spy={true}
              smooth={true}
              offset={-60}
            >
              Fuhrpark
            </Link>)
            :
            (<a className="px-4 py-2 hover:text-amber-500" href="/#fuhrpark">Fuhrpark</a>)
          }
        </li>
        <li className="font-medium text-sm cursor-pointer">
          {location.pathname === '/' ?
            (<Link
              onClick={() => toggleSidebar(!sidebarOpen)}
              activeClass="border-b-2 border-amber-500 text-amber-500"
              className="px-4 py-2 hover:text-amber-500"
              to="contact"
              spy={true}
              smooth={true}
              offset={-60}
            >
              Contact
            </Link>)
            :
            (<a className="px-4 py-2 hover:text-amber-500" href="/#contact">Kontakt</a>)
          }
        </li>
      </ul>
    </nav>
  );
}
